import {FacetService} from "@spartacus/storefront";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {AimoFacet, AimoFacetValue} from "../../model/product.model";

@Injectable({
    providedIn: 'root',
})
export class AimoFacetService extends FacetService {

    getCategoryLevel2Title(): Observable<string> {
        return this.getSelectedCategoryLevel2().pipe(
            map(l => l?.name)
        )
    }

    getSelectedCategoryLevel2(): Observable<AimoFacetValue> {
        return this.facetList$.pipe(
            map((fl) => fl.facets.find((facet: AimoFacet) => facet.code === 'category')?.values
                .find(value => value.selected) ?
                fl.facets
                    .filter((facet: AimoFacet) => facet.code === 'categoryLevel2')
                    .flatMap((facet: AimoFacet) => facet.values)
                    .find(value => value.selected)
                : undefined
            )
        );
    }
}
